import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
export const GET_EMAIL_BY_CAMPAIGN_ID = registerQuery({
  fieldName: 'emailByCampaignId',
  args: ['portalId', 'emailCampaignId'],
  fetcher({
    portalId,
    emailCampaignId
  }) {
    return HttpClient.put('cosemail/v1/emails/search/by-ids', {
      query: {
        portalId
      },
      data: {
        emailCampaignIds: [emailCampaignId]
      }
    });
  }
});
export const GET_EMAIL_SUBSCRIPTIONS = registerQuery({
  fieldName: 'emailSubscriptions',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('subscriptions/v1/definitions', {
      query: {
        portalId,
        includeInternal: true
      }
    });
  }
});
export const GET_EMAIL_BY_EMAIL_ID = registerQuery({
  fieldName: 'emailByEmailId',
  args: ['portalId', 'emailId'],
  fetcher({
    portalId,
    emailId
  }) {
    return HttpClient.get('cosemail/v1/emails', {
      query: {
        portalId,
        id__in: [emailId],
        property: ['id', 'name'],
        limit: 1
      }
    });
  }
});